import Image, { StaticImageData } from 'next/image';
import { Link } from '@/navigation';
import style from './style.module.css';

interface CardFilterProps {
  cards?: {
    image: StaticImageData;
    linkToFilter: string;
    queryParams?: string;
    text: string;
  }[];
  textButton: string;
  cardFilterIcon: StaticImageData;
  linkButtonAll: string;
  title: string;
}

const BenefitsFilter: React.FC<CardFilterProps> = ({
  cards,
  title,
  textButton,
  cardFilterIcon: CardIcon,
  linkButtonAll,
}) => {
  return (
    <div className={style.cardFilterContainer}>
      <h3 className={style.cardFilterTitle}>{title}</h3>
      <div className={style.cardFilterContent}>
        {cards?.map(({ image, text, linkToFilter, queryParams }) => (
          <Link
            key={text}
            href={{ pathname: linkToFilter, query: queryParams }}
            className={`${style.card} ${style.cardNoButton}`}>
            <Image className={style.imgCards} src={image} alt="heart" />
            <p
              className={style.descriptionCardFilter}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </Link>
        ))}

        <Link
          href={linkButtonAll as any}
          className={`${style.card} ${style.cardButton}`}>
          <Image className={style.imgCards} src={CardIcon} alt="card" />
          <p
            className={style.descriptionCardFilter}
            dangerouslySetInnerHTML={{ __html: textButton }}
          />
        </Link>
      </div>
    </div>
  );
};

export default BenefitsFilter;
